import React from "react";
import {
	AddressIcon,
	AgreeIcon,
	CalenderIcon,
	DropdownIcon,
	FileIcon,
	LinkIcon,
	LongTextIcon,
	MultiCheckboxIcon,
	RadioIcon,
	SelectIcon,
	ShortTextIcon,
	TagIcon,
	WritingIcon,
} from "~/assets/svg/DynamicFormIcon";
import translation from "~/i18n";

export const optionList = [
	{
		label: (
			<>
				<ShortTextIcon />
				{translation.t("pages.round.RoundReg.Inquiry.util.optionData.short")}
			</>
		),
		value: "SHORT",
	},
	{
		label: (
			<>
				<LongTextIcon />
				{translation.t("pages.round.RoundReg.Inquiry.util.optionData.long")}
			</>
		),
		value: "LONG",
	},
	// {
	// 	label: (
	// 		<>
	// 			<SelectIcon />
	// 			{translation.t("pages.round.RoundReg.Inquiry.util.optionData.choice")}
	// 		</>
	// 	),
	// 	value: "CHOICE",
	// },
	{
		label: (
			<>
				<RadioIcon />
				{translation.t("pages.round.RoundReg.Inquiry.util.optionData.alternative")}
			</>
		),
		value: "ALTERNATIVE",
	},
	{
		label: (
			<>
				<AgreeIcon />
				{translation.t("pages.round.RoundReg.Inquiry.util.optionData.agree")}
			</>
		),
		value: "AGREE",
	},
	{
		label: (
			<>
				<WritingIcon />
				{translation.t("pages.round.RoundReg.Inquiry.util.optionData.text")}
			</>
		),
		value: "TEXT",
	},
	{
		label: (
			<>
				<FileIcon />
				{translation.t("pages.round.RoundReg.Inquiry.util.optionData.file")}
			</>
		),
		value: "FILE",
	},
	{
		label: (
			<>
				<LinkIcon />
				{translation.t("pages.round.RoundReg.Inquiry.util.optionData.link")}
			</>
		),
		value: "LINK",
	},
	{
		label: (
			<>
				<AddressIcon />
				{translation.t("pages.round.RoundReg.Inquiry.util.optionData.address")}
			</>
		),
		value: "ADDRESS",
	},
	{
		label: (
			<>
				<TagIcon />
				{translation.t("pages.round.RoundReg.Inquiry.util.optionData.tag")}
			</>
		),
		value: "TAG",
	},
	{
		label: (
			<>
				<CalenderIcon />
				{translation.t("pages.round.RoundReg.Inquiry.util.optionData.date")}
			</>
		),
		value: "DATE",
	},
	{
		label: (
			<>
				<DropdownIcon />
				단일선택형
			</>
		),
		value: "SELECT",
	},
	{
		label: (
			<>
				<MultiCheckboxIcon />
				다중선택형
			</>
		),
		value: "MULTISELECT",
	},
];
